'use strict';

function AutoFocusDirective($timeout) {
    'ngInject';
    return {
        restrict: 'AC',
        link: function(_scope, _element) {
            $timeout(function() {
                _element[0].focus();
            }, 0);
        }
    };
};

export default AutoFocusDirective;
